module.exports = __webpack_public_path__ + "images/emoji/snail.8f2e1b2be0b91645178c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/snail.png
// module id = 10We
// module chunks = 13